(function () {
  function handleScroll(){
    const arrow = document.getElementById('sticky-arrow');
    const footer = document.querySelector('.CarpentryComponent--root[data-component-name="ltc-wpm-footer"]');

    if (!arrow || !footer || document.body.scrollHeight <= 5000) {
      arrow?.classList.remove('StickyArrow--show');
      return;
    }

    const footerRect = footer.getBoundingClientRect();
    if (window.scrollY >= 3000 && footerRect.top > window.innerHeight) {
      arrow.classList.add('StickyArrow--show');
    } else {
      arrow.classList.remove('StickyArrow--show');
    }
  }

  function initScrollToTopButton() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('sticky-arrow').addEventListener('click', initScrollToTopButton);
  });

  window.addEventListener('scroll', handleScroll);
})();
